import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, iconColor, actionLabel, actionPath, actionIcon }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200">
      <div className="flex items-start gap-4 mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${iconColor}`}>
          <Icon name={icon} size={24} color="white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-card-foreground mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      <Button 
        variant="outline" 
        fullWidth 
        iconName={actionIcon} 
        iconPosition="right"
        onClick={() => navigate(actionPath)}
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default QuickActionCard;